const nl = {
  app: {
    title: 'AllPhi F&A',
    platformSubtitle: 'Managementplatform',
    searchPlaceholder: 'Zoek in hubgegevens...',
    openGlobalSearch: 'Globaal zoeken openen',
    clearSearch: 'Zoekopdracht wissen en sluiten',
    searchMinimum: 'Typ minstens 2 tekens om in de hele applicatie te zoeken.',
    searchNoResults: 'Geen resultaten gevonden voor “{{term}}”.',
    searchError: 'Sommige zoekresultaten konden niet worden geladen. Probeer opnieuw.',
    searchPages: {
      assets: 'Alle assets',
      contracts: 'Alle contracten',
      documents: 'Documentzoeker',
      notifications: 'Meldingscentrum',
      mobility: 'Mobiliteit per werknemer',
    },
    darkMode: 'Donkere modus',
    lightMode: 'Lichte modus',
    notifications: 'Meldingen',
    openNotifications: 'Meldingen openen',
    openNavigation: 'Navigatie openen',
    collapseSidebar: 'Zijbalk inklappen',
    expandSidebar: 'Zijbalk uitklappen',
    expandNavigationModule: '{{module}} uitklappen',
    collapseNavigationModule: '{{module}} inklappen',
    accountMenu: 'Accountmenu',
    signOut: 'Afmelden',
    notificationCenter: 'Meldingscentrum',
    notificationSubtitle: 'Volg openstaande items uit je toegankelijke modules',
    openCount: '{{count}} open',
    unreadNewCount: '{{count}} nieuw',
    openNotificationCenterPage: 'Volledig meldingscentrum openen',
    entityAsset: 'Asset',
    entityContract: 'Contract',
    entityExpenseClaim: 'Onkostennota',
    newBadge: 'Nieuw',
    dueLabel: 'Te doen voor: {{date}}',
    reminderLabel: 'Herinnering: {{date}}',
    openButton: 'Openen',
    inOrder: 'In orde',
    allClear: 'Alles in orde',
    noActiveNotifications: 'Geen actieve meldingen.',
    markedInOrderSuccess: 'Gemarkeerd als in orde.',
    language: 'Taal',
    dutch: 'Nederlands',
    english: 'Engels',
  },
  auth: {
    title: 'AllPhi F&A Platform',
    subtitle: 'Meld je aan met je Microsoft-werkaccount om verder te gaan.',
    signIn: 'Aanmelden',
    accessDeniedTitle: 'Geen toegang',
    accessDeniedSubtitle: 'Je account heeft geen toegang tot deze toepassing. Vraag toegang via de AllPhi Admin-groep.',
  },
  home: {
    title: 'AllPhi F&A Platform',
    welcome: 'Welkom, {{name}}',
    instruction: 'Gebruik de navigatie aan de linkerkant om naar de onderdelen te gaan waartoe je toegang hebt.',
    noModuleAccess: 'Je account heeft momenteel geen toegang tot een functionele module. Via Beheer kun je de beschikbare toegangsrechten bekijken.',
  },
  modules: {
    home: 'Home',
    assets: 'Assets',
    notifications: 'Meldingen',
    contracts: 'Leverancierscontracten',
    allAssets: 'Alle assets',
    spareAssets: 'Reserve assets',
    endOfLease: 'Einde lease',
    notificationCenter: 'Meldingscentrum',
    contractsDashboard: 'Contractdashboard',
    contractsAll: 'Alle contracten',
    contractsEndingSoon: 'Verloopt binnenkort',
    contractsNoticeLead: 'Opzegvoorloop',
    contractDocumentsSearch: 'Documentzoeker',
    supplierContracts: 'Leverancierscontracten',
    changeHistory: 'Wijzigingsgeschiedenis',
    administration: 'Beheer',
    mobility: 'Mobiliteitsbudget',
    mobilityAccounts: 'Werknemersoverzicht',
    mobilityClaims: 'Onkostennota\u2019s',
    mobilityPayroll: 'Loonverwerking',
  },
  audit: {
    title: 'Wijzigingsgeschiedenis',
    moduleTitle: 'Wijzigingsgeschiedenis {{module}}',
    objectTitle: 'Geschiedenis van {{name}}',
    subtitle: 'Bekijk creaties, wijzigingen, documentacties en verwijderingen. Verwijderde objecten blijven in deze geschiedenis zichtbaar.',
    history: 'Geschiedenis',
    openHistory: 'Geschiedenis bekijken',
    search: 'Zoek op object of gebruiker',
    action: 'Actie',
    allActions: 'Alle acties',
    date: 'Datum en tijd',
    object: 'Object',
    changedBy: 'Uitgevoerd door',
    changes: 'Oude en nieuwe waarde',
    before: 'Voor',
    after: 'Na',
    fields: {
      AssetTag: 'Servicetagnummer',
      Category: 'Categorie',
      Manufacturer: 'Fabrikant',
      Model: 'Model',
      SerialNumber: 'Voormalig serienummer',
      Specifications: 'Specificaties',
      PurchaseType: 'Aankooptype',
      PurchaseDate: 'Aankoopdatum',
      LeasingPrice: 'Leaseprijs',
      LeasingStartDate: 'Startdatum lease',
      LeasingEndDate: 'Einddatum lease',
      ContractNumber: 'Contractnummer',
      PaymentMethod: 'Betaalmethode',
      LeasingCompany: 'Leasemaatschappij',
      AssignedEmployeeId: 'Toegewezen gebruiker',
      OfficeLocationId: 'Kantoorlocatie',
      KeyboardLayout: 'Toetsenbordindeling',
      HasDongle: 'Dongle aanwezig',
      BillingTiming: 'Type facturatie',
      Status: 'Status',
      Notes: 'Notities',
      CostLines: 'Kostlijnen',
      EndDate: 'Einddatum',
    },
    empty: 'Er zijn nog geen wijzigingen geregistreerd.',
    system: 'Systeem',
    actions: {
      Created: 'Aangemaakt',
      Updated: 'Gewijzigd',
      Deleted: 'Verwijderd',
      DocumentUploaded: 'Document geüpload',
      DocumentRenamed: 'Document hernoemd',
      DocumentDeleted: 'Document verwijderd',
      AccessChanged: 'Toegang gewijzigd',
    },
  },
  admin: {
    lastAdministratorProtected: 'De laatste beheerder kan zijn eigen beheerdersrol niet verwijderen.',
    title: 'Gebruikers- en moduletoegang',
    subtitle: 'Beheer applicatiebeheerders en bepaal per gebruiker welke modules zichtbaar en toegankelijk zijn.',
    entraExplanation: 'De gebruikerslijst wordt alleen-lezen geladen uit de ingestelde Entra-groep. Deze schakelaars wijzigen geen groepslidmaatschappen; de rechten worden in deze applicatie opgeslagen.',
    entraExplanationCompact: 'Gebruikers komen uit de Entra-groep; rechten worden automatisch in deze applicatie opgeslagen.',
    accessDenied: 'Je hebt geen toegang tot deze beheerpagina.',
    search: 'Zoek gebruiker',
    user: 'Gebruiker',
    admin: 'Beheerder',
    actions: 'Actie',
    defaultAccess: 'Standaardtoegang — nog niet expliciet opgeslagen',
    defaultAccessShort: 'Standaard',
    contractsShort: 'Contracten',
    mobilityShort: 'Mobiliteit',
    notificationsShort: 'Meldingen',
    employeeSyncCompleted: '{{count}} Entra-werknemers gesynchroniseerd: {{created}} nieuw, {{reactivated}} opnieuw actief en {{deactivated}} inactief gemaakt.',
    syncEmployees: 'Werknemers synchroniseren',
    saving: 'Opslaan…',
    savedShort: 'Opgeslagen',
    saveFailed: 'Niet opgeslagen',
    saved: 'Toegang voor {{name}} opgeslagen.',
    previewNonAdmin: 'Bekijken als niet-beheerder',
    previewActive: 'Preview als niet-beheerder is actief',
    previewExplanation: 'Dit is alleen een visuele preview. Je echte rechten en opgeslagen instellingen blijven ongewijzigd.',
    endPreview: 'Preview beëindigen',
    readOnlyExplanation: 'Je bekijkt deze pagina in alleen-lezenmodus. Alleen beheerders kunnen beheerdersrechten en moduletoegang wijzigen.',
  },
  notifications: {
    title: 'Meldingscentrum',
    subtitle: 'Beheer lifecycle-status, notities en volledige historiek per melding.',
    filterStatus: 'Statusfilter',
    allStatuses: 'Alle statussen',
    filterUnread: 'Ongelezen filter',
    filterEntityType: 'Meldingsbron',
    allEntityTypes: 'Alle toegankelijke modules',
    contracts: 'Contracten',
    assets: 'Assets',
    expenseClaims: 'Onkostennota’s',
    filterAssetType: 'Assettype',
    allAssetTypes: 'Alle assettypes',
    laptop: 'Laptop',
    dockingStation: 'Dockingstation',
    allItems: 'Alle items',
    onlyUnread: 'Enkel ongelezen',
    noteLabel: 'Notitie of opmerking',
    markSeen: 'Markeer als gelezen',
    setInProgress: 'Zet op In behandeling',
    setClosed: 'Zet op Gesloten',
    setExtended: 'Zet op Verlengd',
    addComment: 'Opmerking toevoegen',
    history: 'Historiek',
    historyTitle: 'Meldingshistoriek',
    historyCycleHelp: 'Cyclus betekent hoe vaak dezelfde melding opnieuw actief werd na een eerdere sluiting.',
    actedBy: 'Door: {{name}}',
    noHistory: 'Geen historiek beschikbaar.',
    historyCycle: 'Cyclus {{cycle}}',
    seen: 'Gelezen',
    unseen: 'Ongelezen',
    statusUpdated: 'Meldingsstatus bijgewerkt.',
    commentAdded: 'Opmerking toegevoegd aan historiek.',
    commentRequired: 'Voeg eerst een opmerking toe in het notitieveld.',
    noteModalHint: 'Notitie of opmerking wordt gevraagd in een pop-up bij een actie.',
    noteModalTitleStatus: 'Status bijwerken',
    noteModalTitleComment: 'Opmerking toevoegen',
    noteModalPlaceholderStatus: 'Voeg optioneel een notitie toe bij deze statuswijziging...',
    noteModalPlaceholderComment: 'Typ je opmerking voor deze melding...',
    columns: {
      status: 'Status',
      title: 'Titel',
      message: 'Bericht',
      dueDate: 'Vervaldatum',
      seen: 'Gelezen',
      actions: 'Acties',
    },
    statuses: {
      New: 'Nieuw',
      InProgress: 'In behandeling',
      Closed: 'Gesloten',
      Extended: 'Verlengd',
    },
    historyActions: {
      Created: 'Aangemaakt',
      StatusChanged: 'Status gewijzigd',
      Reopened: 'Heropend',
      NoteAdded: 'Notitie toegevoegd',
      MarkedSeen: 'Gemarkeerd als gelezen',
      AutoResolved: 'Automatisch opgelost',
    },
    historyNotes: {
      reopenedActive: 'Melding heropend omdat de voorwaarde nog actief is.',
      reopenedNewCycle: 'Melding heropend in een nieuwe cyclus.',
      markedSeen: 'Melding gemarkeerd als gelezen.',
      created: 'Melding aangemaakt.',
      autoResolved: 'Automatisch opgelost omdat de voorwaarde niet langer geldt.',
      closedByUser: 'Door gebruiker afgesloten.',
    },
    generated: {
      contractNoticeTitle: 'Contract {{name}} in opzegvenster',
      contractNoticeMessage: 'Opzegperiode start op {{date}} voor contract {{name}}.',
      contractPendingSignatureTitle: 'Contract {{name}} wacht op handtekening',
      contractPendingSignatureMessage: 'Contract {{name}} wacht nog op handtekening. Geplande startdatum: {{date}}.',
      rentalContractTitle: 'Opzegperiode huurcontract {{name}} nadert',
      rentalContractMessage: 'De opzegperiode voor huurcontract {{name}} start op {{date}}.',
      assetLeaseTitle: 'Lease van asset {{name}} loopt bijna af',
      assetLeaseMessage: 'Lease eindigt op {{date}} voor asset {{name}}.',
      expenseClaimTitle: 'Nieuwe onkostennota ter beoordeling',
    },
  },
  common: {
    invalidDateFormat: 'Gebruik een geldige datum in het formaat dd/mm/jjjj.',
    datePlaceholder: 'dd/mm/jjjj',
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
    close: 'Sluiten',
    save: 'Opslaan',
    create: 'Aanmaken',
    saveChanges: 'Wijzigingen opslaan',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    yes: 'Ja',
    no: 'Nee',
    all: 'Alle',
    noData: '-',
  },
  comingSoon: {
    notFound: 'Niet gevonden',
    message: 'Dit onderdeel is gepland voor een volgende opleverfase en is nog niet beschikbaar.',
  },
  assets: {
    pageTitle: 'Alle assets',
    newAsset: 'Nieuwe asset(s)',
    exportCsv: 'Exporteren naar Excel',
    laptops: 'Laptops',
    dockingStations: 'Dockingstations',
    status: 'Status',
    purchaseType: 'Aankooptype',
    columns: {
      assetTag: 'Servicetagnummer',
      category: 'Categorie',
      manufacturer: 'Fabrikant',
      model: 'Model',
      purchaseType: 'Aankooptype',
      keyboard: 'Toetsenbord',
      dongle: 'Dongle',
      billingTiming: 'Type facturatie',
      contractNumber: 'Contractnummer',
      leaseEndDate: 'Lease-einddatum',
      assignedTo: 'Toegewezen aan',
      formerAssignedTo: 'Voormalige gebruiker',
      office: 'Kantoor',
      createdAt: 'Aangemaakt op',
      modifiedAt: 'Gewijzigd op',
      actions: '',
    },
    labels: {
      spare: 'Reserve',
      reservedLegacy: 'Gereserveerd (legacy)',
      purchased: 'Aangekocht',
      leasing: 'Lease',
    },
    statuses: {
      assigned: 'Toegewezen',
      spareLaptop: 'Reserve',
      reserved: 'Gereserveerd (legacy)',
      repair: 'In herstelling',
      endOfLease: 'Einde lease',
      returned: 'Teruggebracht',
      retired: 'Uit dienst',
      broken: 'Stuk',
    },
    billingTiming: {
      advance: 'Vooruit',
      arrears: 'Achteraf',
    },
    filters: {
      category: 'Assettype',
      keyboardLayout: 'Toetsenbordindeling',
      statusCount: '{{count}} statussen',
    },
    createDialog: {
      title: 'Nieuwe asset(s)',
      subtitle: 'Voeg één of meerdere laptops en dockingstations toe met hun volledige gegevens.',
      assetCount_one: '{{count}} asset',
      assetCount_other: '{{count}} assets',
      untitledAsset: 'Nieuw asset',
      duplicate: 'Gegevens dupliceren',
      remove: 'Asset verwijderen',
      addAnother: 'Nog een asset toevoegen',
      create_one: 'Asset aanmaken',
      create_other: '{{count}} assets aanmaken',
    },
    snack: {
      assetDeleted: 'Asset verwijderd',
      provideOneAssetTag: 'Geef minstens één assettag op.',
      createdAssets: '{{count}} assets aangemaakt.',
      bulkUpdated: '{{count}} assets zijn bijgewerkt.',
    },
    bulkEdit: {
      action: 'Bulk edit ({{count}})',
      title: 'Assets in bulk bewerken',
      help: 'Kies welke waarde je voor {{count}} geselecteerde assets wilt aanpassen. Elke wijziging wordt per asset geregistreerd.',
      leaseEndDate: 'Lease-einddatum',
      status: 'Status',
      newEndDate: 'Nieuwe lease-einddatum',
      newStatus: 'Nieuwe status',
      confirm: 'Assets bijwerken',
    },
    confirmDeleteTitle: 'Asset verwijderen',
    confirmDeleteMessage: 'Weet je zeker dat je deze asset wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    actions: {
      view: 'Bekijken',
      edit: 'Bewerken',
      delete: 'Verwijderen',
    },
  },
  assetForm: {
    editTitle: 'Asset bewerken',
    createTitle: 'Nieuwe asset',
    fields: {
      assetTag: 'Servicetagnummer',
      category: 'Categorie',
      manufacturer: 'Fabrikant',
      model: 'Model',
      keyboardLayout: 'Toetsenbordindeling',
      hasDongle: 'Dongle aanwezig',
      billingTiming: 'Type facturatie',
      specifications: 'Specificaties',
      purchaseType: 'Aankooptype',
      status: 'Status',
      assignedTo: 'Toegewezen aan',
      officeLocation: 'Kantoorlocatie',
      purchaseDate: 'Aankoopdatum',
      leasingCompany: 'Leasebedrijf',
      contractNumber: 'Contractnummer',
      leasingPrice: 'Leaseprijs',
      leaseStart: 'Lease start',
      leaseEnd: 'Lease einde',
      notes: 'Notities',
    },
    statuses: {
      spare: 'Reserve',
    },
    actions: {
      create: 'Aanmaken',
      saveChanges: 'Wijzigingen opslaan',
    },
    validation: {
      required: 'Dit veld is verplicht.',
    },
    snack: {
      updated: 'Asset bijgewerkt',
      created: 'Asset aangemaakt',
    },
  },
  assetDetails: {
    title: 'Assetdetails',
    noAsset: 'Geen asset geselecteerd.',
    assignmentHistoryTitle: 'Toewijzingsgeschiedenis',
    loadingHistory: 'Geschiedenis laden...',
    noAssignmentHistory: 'Nog geen toewijzingsgeschiedenis beschikbaar.',
    historyPeriodFrom: 'Van {{date}}',
    historyPeriodTo: 'Tot {{date}}',
    historyCurrent: 'Huidige toewijzing',
    historyPeriodUnknown: 'Periode onbekend',
    labels: {
      assetTag: 'Servicetagnummer',
      category: 'Categorie',
      manufacturer: 'Fabrikant',
      model: 'Model',
      keyboardLayout: 'Toetsenbordindeling',
      hasDongle: 'Dongle aanwezig',
      billingTiming: 'Type facturatie',
      purchaseType: 'Aankooptype',
      purchaseDate: 'Aankoopdatum',
      leasingEnd: 'Lease einde',
      leasingPrice: 'Leaseprijs',
      contractNumber: 'Contractnummer',
      status: 'Status',
      assignedTo: 'Toegewezen aan',
      formerAssignedTo: 'Voormalige gebruiker',
      office: 'Kantoor',
      note: 'notitie',
    },
    metadataTitle: 'Extra Info',
    noMetadata: 'Geen CSV-metadata gevonden.',
  },
  spareAssets: {
    title: 'Reserve assets',
    subtitle: 'Assets die momenteel in reserve-status staan. De kantoorlocatie kan in het assetdossier worden aangevuld.',
    columns: {
      assetTag: 'Servicetagnummer',
      manufacturer: 'Fabrikant',
      model: 'Model',
      keyboard: 'Toetsenbord',
      office: 'Kantoor',
      leaseEnd: 'Lease einde',
    },
  },
  endOfLease: {
    title: 'Einde lease',
    subtitle: 'Assets met een lease-einddatum tussen vandaag en de volgende {{months}} maanden.',
    columns: {
      assetTag: 'Servicetagnummer',
      manufacturer: 'Fabrikant',
      model: 'Model',
      contract: 'Contract',
      leaseEndDate: 'Lease-einddatum',
      daysLeft: 'Dagen resterend',
      assignedTo: 'Toegewezen aan',
      office: 'Kantoor',
    },
    days: '{{count}} dagen',
  },
  contracts: {
    incompleteFlag: 'Contract is gemarkeerd als niet compleet',
    pendingSignature: 'Wacht op handtekening',
    title: 'Leverancierscontracten',
    subtitle: 'Actieve contracten, vervaldata en leveranciersverplichtingen.',
    views: {
      all: {
        title: 'Alle contracten',
        subtitle: 'Alle leverancierscontracten, ongeacht lifecycle-venster.',
      },
      endingSoon: {
        title: 'Contracten die binnenkort eindigen',
        subtitle: 'Contracten die eindigen tussen {{min}} en {{max}} maanden vanaf vandaag.',
      },
      noticeLead: {
        title: 'Opzegvoorloopvenster',
        subtitle: 'Contracten waarvan de opzegstart tussen {{min}} en {{max}} maanden vanaf vandaag valt.',
      },
    },
    newContract: 'Nieuw contract',
    filters: {
      contractType: 'Contracttype',
      allContractTypes: 'Alle contracttypes',
      noticeLeadMinMonths: 'Vanaf (maanden)',
      noticeLeadMaxMonths: 'Tot (maanden)',
      endingSoonMinMonths: 'Vanaf (maanden)',
      endingSoonMaxMonths: 'Tot (maanden)',
      status: 'Status',
    },
    cards: {
      active: 'Actief',
      activeSplit: 'Doorlopend: {{standard}} · Eenmalig: {{oneTime}} · Huur: {{rental}}',
      expiring90: 'Verloopt binnen 90 dagen',
      totalValueAnnualized: 'Totale waarde (alle contracten, jaarbasis)',
      totalRecurringAnnualized: 'Doorlopende waarde (jaarbasis)',
      totalOneTimeCommitment: 'Eenmalige verplichtingen: EUR {{value}}',
      expired: 'Verlopen',
    },
    columns: {
      title: 'Titel',
      supplier: 'Leverancier',
      contractValue: 'Contractwaarde (jaarlijks)',
      endDate: 'Einddatum',
      noticePeriod: 'Opzegtermijn',
      daysLeft: 'Dagen resterend',
      status: 'Status',
      shortNote: 'Korte notitie',
    },
    expiredCell: 'Verlopen',
    confirmDeleteTitle: 'Contract "{{title}}" ({{supplier}}) verwijderen?',
    confirmDeleteMessage: 'Dit contract en alle geüploade documenten worden verwijderd.',
    snack: {
      deleted: 'Contract verwijderd',
    },
    actions: {
      view: 'Bekijken',
      edit: 'Bewerken',
      delete: 'Verwijderen',
    },
    statuses: {
      draft: 'Concept',
      active: 'Actief',
      pendingSignature: 'Wacht op handtekening',
      expired: 'Verlopen',
      terminated: 'Stopgezet',
    },
  },
  contractDashboard: {
    title: 'Contractdashboard',
    subtitle: 'Inzicht in contractstatus, termijnen, volledigheid en financiële verplichtingen.',
    period: 'Weergave',
    month: 'Maand',
    year: 'Jaar',
    currency: 'Valuta',
    allCurrencies: 'Alle valuta',
    showDetails: 'Bekijk onderliggende contracten',
    noContracts: 'Geen contracten voor deze statistiek in de geselecteerde periode.',
    contractCount: '{{count}} contract(en)',
    periodExplanation: 'De cijfers gelden voor {{start}} tot en met {{end}}. Doorlopende waarde wordt geannualiseerd; eenmalige verplichtingen worden geteld bij de startdatum van het contract.',
    currencyExplanation: 'Bedragen in verschillende valuta worden afzonderlijk getoond en nooit bij elkaar opgeteld.',
    metrics: {
      totalContracts: { title: 'Contracten in periode' },
      activeContracts: { title: 'Actieve contracten' },
      incompleteContracts: { title: 'Niet complete contracten' },
      startingInPeriod: { title: 'Start in deze periode' },
      endingInPeriod: { title: 'Einde in deze periode' },
      noticeDeadlinesInPeriod: { title: 'Opzegdeadlines' },
      indefiniteContracts: { title: 'Onbepaalde duur' },
      missingDocuments: { title: 'Zonder documenten' },
      recurringAnnualValue: { title: 'Doorlopende waarde (jaarbasis)' },
      oneTimeCommitment: { title: 'Eenmalige verplichtingen' },
    },
  },
  contractDetails: {
    title: 'Contractdetails',
    loading: 'Contractdetails laden...',
    supplier: 'Leverancier',
    contractName: 'Contractnaam',
    contractType: 'Contracttype',
    status: 'Status',
    incomplete: 'Niet compleet — aandacht vereist',
    startDate: 'Startdatum',
    endDate: 'Einddatum',
    costs: 'Jaarlijkse kosten',
    costLines: 'Kostlijnen',
    documents: 'Geüploade documenten',
    noticePeriod: 'Opzegtermijn',
    noticeDeadline: 'Uiterste opzegdatum',
    renewalInformation: 'Verlengingsinformatie',
    fixedTermRenewal: 'Contract met vaste looptijd tot {{date}}.',
    indefiniteRenewal: 'Contract van onbepaalde duur; er is geen verlengings- of einddatum gepland.',
    indefinite: 'Onbepaalde duur',
    notSet: 'Niet ingesteld',
    notApplicable: 'Niet van toepassing',
    notificationInfo: {
      label: 'Informatie over meldingsmoment',
      title: 'Wanneer wordt de melding gegenereerd?',
      oneTime: 'Voor een eenmalige overeenkomst worden geen meldingen gegenereerd.',
      missingEndDate: 'Er wordt geen datumgestuurde melding gegenereerd zolang geen einddatum is ingesteld.',
      missingNoticePeriod: 'Er wordt geen datumgestuurde melding gegenereerd zolang geen opzegtermijn is ingesteld.',
      standard: 'De melding wordt gegenereerd op {{date}}, één maand vóór de uiterste opzegdatum {{noticeDate}}.',
      rental: 'De melding wordt gegenereerd op {{date}}, zes maanden vóór de start van de opzegperiode op {{noticeDate}}.',
      pendingSignature: 'Er is nu een melding omdat het contract wacht op handtekening. Na activatie geldt: {{schedule}}',
      inactive: '{{schedule}} De datumgestuurde melding wordt alleen aangemaakt wanneer het contract actief is.',
      notAvailable: 'De meldingsdatum kon niet worden berekend.',
    },
  },
  contractDocumentSearch: {
    title: 'Zoeken in contractdocumenten',
    subtitle: 'Zoek in alle geüploade contractdocumenten op bestandsnaam, en in PDF’s ook op inhoud.',
    searchLabel: 'Zoekterm',
    searchPlaceholder: 'Zoek op leverancier, factuurtekst, clausule of trefwoord...',
    supplierLabel: 'Leverancierfilter (optioneel)',
    searchButton: 'Zoeken',
    globalHint: 'Tip: tekst in de zoekbalk bovenaan wordt hier ook gebruikt.',
    minSearchHint: 'Voer minstens 2 tekens in om documenten te zoeken.',
    indexCoverage: 'Geindexeerde inhoud: {{extracted}} / {{total}} documenten',
    noSnippet: 'Geen tekstsnippet beschikbaar voor dit resultaat.',
    open: 'Openen',
    columns: {
      fileName: 'Bestandsnaam',
      contract: 'Contract',
      supplier: 'Leverancier',
      snippet: 'Passende snippet',
      matches: 'Matchbron',
    },
    matchTags: {
      fileName: 'Bestandsnaam',
      content: 'Inhoud',
    },
  },
  contractForm: {
    editTitle: 'Contract bewerken',
    createTitle: 'Nieuw contract',
    loadingDetails: 'Contractdetails laden...',
    fields: {
      supplier: 'Leverancier',
      title: 'Titel',
      completeness: 'Volledigheid van contract',
      contractDate: 'Contractdatum',
      startDate: 'Startdatum',
      endDate: 'Einddatum',
      contractType: 'Contracttype',
      currency: 'Valuta',
      noticePeriod: 'Opzegtermijn',
      noticePeriodDisabledForOneTime: 'Opzegtermijn is niet van toepassing op eenmalige contracten.',
      unit: 'Eenheid',
      status: 'Status',
      shortNote: 'Korte notitie',
      notes: 'Notities',
      setStatusManually: 'Status handmatig instellen',
      costLines: 'Kostlijnen',
      addLine: 'Lijn toevoegen',
      label: 'Label',
      costLineLabelPlaceholder: 'Vaste kost',
      quantity: 'Aantal',
      unitPrice: 'Prijs per eenheid',
      periodType: 'Periode',
      removeCostLine: 'Kostlijn verwijderen',
    },
    completeness: {
      complete: 'Compleet',
      incomplete: 'Niet compleet',
      help: 'Markeer als niet compleet wanneer informatie of documentatie ontbreekt.',
    },
    periods: {
      monthly: 'Maandelijks',
      quarterly: 'Per kwartaal',
      yearly: 'Jaarlijks',
      oneTime: 'Eenmalig',
      fullContract: 'Volledige contractduur',
    },
    noticeUnits: {
      days: 'Dagen',
      weeks: 'Weken',
      months: 'Maanden',
    },
    contractTypes: {
      standard: 'Doorlopend contract',
      oneTime: 'Eenmalige overeenkomst',
      rental: 'Huurcontract',
    },
    statusHelp: {
      manualEnabled: 'Handmatige override is ingeschakeld. Zet uit om automatische status op basis van datums te gebruiken.',
      automatic: 'Automatische status: {{status}}',
    },
    document: {
      createDocumentOptional: 'Je kunt optioneel een of meerdere contractdocumenten toevoegen.',
      dropOrBrowse: 'Sleep bestanden hierheen of klik om te bladeren',
      supportedFileTypes: 'PDF, Word, Excel, PowerPoint, OpenDocument, RTF, TXT, CSV, e-mail (MSG, EML) en afbeeldingen (PNG, JPG, TIFF)',
      selected: 'Geselecteerd: {{name}}',
      removeSelectedDocument: 'Verwijderen',
      contractDocuments: 'Contractdocumenten',
      noDocument: 'Nog geen document geüpload.',
      viewDocument: 'Openen',
      deleteDocument: 'Document verwijderen',
      renamePdf: 'Hernoemen',
      renameTitle: 'Document hernoemen',
      fileName: 'Bestandsnaam',
      renamed: 'Document hernoemd.',
      deleted: 'Document verwijderd.',
      uploadNewDocument: 'Nieuw document uploaden',
      unsupportedFileType: '{{name}} heeft een bestandstype dat niet ondersteund wordt.',
    },
    validation: {
      required: 'Dit veld is verplicht.',
      quantityPositive: 'Aantal moet groter zijn dan 0.',
      unitPriceNonNegative: 'De prijs mag niet negatief zijn.',
      priceRequired: 'Vul een geldige prijs in.',
      endDateBeforeStart: 'De einddatum mag niet vóór de startdatum liggen.',
      notesRequiredWhenIncomplete: 'Notities zijn verplicht wanneer het contract als niet volledig is gemarkeerd.',
    },
    actions: {
      create: 'Contract aanmaken',
      saveChanges: 'Wijzigingen opslaan',
    },
    snack: {
      updated: 'Contract bijgewerkt',
      created: 'Contract aangemaakt',
    },
  },
  mobility: {
    fields: {
      employee: 'Werknemer',
      year: 'Jaar',
      annualBudget: 'Jaarbudget',
      availableBalance: 'Beschikbaar saldo',
      status: 'Status',
      actions: 'Acties',
      date: 'Datum',
      entryType: 'Type boeking',
      pillar: 'Pijler',
      amount: 'Bedrag',
      description: 'Omschrijving',
      expenseType: 'Onkostensoort',
      attachments: 'Bijlagen',
    },
    accounts: {
      title: 'Mobiliteitsbudgetrekeningen',
      subtitle: 'Beheer de jaarlijkse mobiliteitsbudgetten van werknemers en hun grootboek.',
      create: 'Nieuwe rekening',
      created: 'Budgetrekening aangemaakt.',
      closed: 'Budgetrekening afgesloten.',
      settled: 'Pijler 3 afgerekend. Netto uitbetaald: {{net}}.',
      ledger: 'Grootboek',
      ledgerTitle: 'Grootboek van {{name}} ({{year}})',
      stateOpen: 'Open',
      stateClosed: 'Afgesloten',
    },
    ledger: {
      subtitle: 'Vrijgaven en uitgaven in duidelijke, chronologische bewegingen. Technische herberekeningen worden niet als verrichting getoond.',
      regularReleased: 'Regulier vrijgegeven',
      expenses: 'Uitgaven',
      noTransactions: 'Nog geen verrichtingen voor dit boekjaar',
      rowsPerPage: 'Rijen per pagina:',
      types: {
        BudgetGrant: 'Jaarbudget',
        CarCost: 'Wagenkost',
        ExpenseReimbursement: 'Onkost',
        CashPayout: 'Uitbetaling pijler 3',
        Adjustment: 'Correctie',
        MonthlyRelease: 'Maandelijkse vrijgave',
        YearlyRelease: 'Jaarlijkse vrijgave',
      },
      descriptions: {
        MonthlyRelease: 'Mobiliteitsbudget vrijgegeven op het einde van de maand',
        YearlyRelease: 'Volledig resterend jaarbudget in één keer vrijgegeven',
        ExpenseReimbursement: 'Terugbetaling onkostennota #{{id}}',
        ExpenseReimbursementDetailed: '{{type}}',
        ExpenseRefund: 'Terugboeking geannuleerde onkostennota #{{id}}',
        ExpenseRefundDetailed: 'Terugboeking: {{type}}',
      },
      reversed: 'Teruggedraaid',
    },
    employeeData: {
      open: 'Werknemersgegevens',
      title: 'Mobiliteitsgegevens werknemers',
      subtitle: 'Beheer per werknemer de startdatum en relevante ervaring die voor de mobiliteitsberekening worden gebruikt.',
      email: 'E-mailadres',
      startDate: 'Datum in dienst',
      relevantYears: 'Relevante ervaring vóór AllPhi (jaar)',
      link: 'Entra gekoppeld',
      editTitle: 'Mobiliteitsgegevens – {{name}}',
      saved: 'Mobiliteitsgegevens opgeslagen.',
      employeeType: 'Type werknemer',
      employeeTypeConsultant: 'Consultant',
      employeeTypeOverhead: 'Overhead',
    },
    employeeOverview: {
      title: 'Mobiliteit per werknemer',
      subtitle: 'Categorieën, huidige wagen, mobiliteitsbudget en onkostennota’s in één overzicht.',
      currentCategory: 'In aanmerking komende categorie',
      assignedCategory: 'Toegewezen categorie',
      absoluteCategory: 'Absolute categorie',
      vehicleCategory: 'Categorie mobiliteitsbudget',
      expenses: 'Onkostennota’s',
      expenseSummary: '{{count}} totaal · {{pending}} open',
      openDetails: 'Volledig werknemersoverzicht openen',
      history: 'Geschiedenis',
      openHistory: 'Geschiedenis bekijken',
      editProfile: 'Gegevens aanpassen',
      activeSince: 'Actief sinds {{date}}',
      notSet: 'Nog niet ingesteld',
      categorySwitchChangedOn: 'Van kracht op {{date}}',
      categorySwitchTakesEffectOn: 'Wordt van kracht op {{date}}',
      absoluteDetail: '{{years}} relevante jaren · {{points}} punten',
      calculatedDetail: 'Berekend op {{years}} relevante jaren · {{points}} punten',
      noVehicle: 'Geen actieve wagen gekoppeld',
      profile: 'Werknemersgegevens',
      budget: 'Mobiliteitsbudget {{year}}',
      expenseTitle: 'Onkostennota’s {{year}}',
      changeEntitledCategoryTitle: 'Toegekende categorie wijzigen – {{name}}',
      changeEntitledCategoryInfo: 'Kies de datum waarop de nieuwe categorie moet ingaan. Dit heeft geen invloed op de wagen of de looptijd van het leasecontract.',
      changeEntitledCategoryEffectiveDate: 'Ingangsdatum',
      changeEntitledCategoryResolvedDate: 'De wijziging gaat in op {{date}}.',
      changeEntitledCategoryVehicleUnaffected: 'Deze wijziging heeft geen invloed op de wagen of de looptijd van het leasecontract.',
      changeEntitledCategoryBookYear: 'Boekjaar {{year}}',
      changeEntitledCategoryDaysSplit: '{{before}} dagen oud / {{after}} dagen nieuw',
      changeEntitledCategoryPreviousBudget: 'Vorig mobiliteitsbudget',
      changeEntitledCategoryNewBudget: 'Nieuw mobiliteitsbudget',
      changeEntitledCategoryBudgetDelta: 'Verschil in budget',
      changeEntitledCategoryConfirm: 'Wijziging bevestigen',
      categorySaved: 'Toegekende categorie gewijzigd.',
      bookYearsTitle: 'Boekjaren mobiliteitsbudget',
      bookYearsSubtitle: 'Dag-pro-rata projectie over de volledige leasingperiode van 48 maanden. Het vrije budget is het bruto TCO-recht min de kost van de gekozen wagen.',
      bookYear: 'Boekjaar',
      activeDays: 'Actieve dagen',
      grossTcoEntitlement: 'Bruto TCO-recht',
      vehicleCost: 'Kost wagen (pijler 1)',
      projectedFreeBudget: 'Geprojecteerd vrij budget',
      noLease: 'Nog geen leasingperiode ingesteld',
      employmentStatus: 'Werkstatus',
      active: 'Actief',
      inactive: 'Inactief',
      allStatuses: 'Alle statussen',
      permanentDelete: 'Definitief verwijderen',
      permanentDeleteTitle: 'Inactief profiel verwijderen',
      permanentDeleteWarning: 'Je verwijdert {{name}} en de accountkoppeling definitief. Profielen met mobiliteits- of loonhistoriek moeten om auditredenen gearchiveerd blijven en kunnen niet definitief worden verwijderd.',
      deleted: 'Het werknemersprofiel is definitief verwijderd.',
      entraLink: 'Entra-koppeling',
      linked: 'Gekoppeld',
      notLinked: 'Niet gekoppeld',
      deleteDuplicate: 'Dubbel profiel verwijderen',
      deleteDuplicateTitle: 'Niet-gekoppeld profiel verwijderen',
      deleteDuplicateWarning: 'Verwijder {{name}} alleen wanneer dit een dubbel, niet-gekoppeld profiel is en het gekoppelde Entra-profiel behouden blijft. Een profiel met mobiliteits- of loonhistoriek kan niet verwijderd worden.',
      budgetAvailability: 'Mobiliteitsbudget',
      available: 'Beschikbaar',
      unavailable: 'Niet actief',
      budgetEnabled: 'Het mobiliteitsbudget is geactiveerd.',
      budgetDisabled: 'Het mobiliteitsbudget is uitgeschakeld.',
      budgetInactiveInfo: 'Het mobiliteitsbudget is nog niet actief voor deze werknemer. De interne lease- en boekjaarprojectie blijft zichtbaar voor F&A, maar er worden nog geen budgetrekening, vrijgaves of werknemersacties geactiveerd.',
      releaseModeMonthly: 'Maandelijkse vrijgave',
      releaseModeYearly: 'Jaarlijkse vrijgave',
    },
    leaverSimulation: {
      action: 'Simuleer uitdiensttreding-afrekening',
      title: 'Simulatie afrekening mobiliteitsbudget bij uitdiensttreding',
      explanation: 'Dit is een louter informatieve projectie van wat aan of door de werknemer verschuldigd zou zijn bij vertrek op de gekozen datum. Er worden geen boekingen uitgevoerd en de rekening wordt niet gewijzigd.',
      departureDate: 'Datum uitdiensttreding',
      calculate: 'Berekenen',
      annualBudget: 'Jaarbudget',
      standardReleased: 'Normaal vrijgegeven tot nu',
      releaseBreakdownTitle: 'Overzicht vrijgaves',
      alreadyReleased: 'Reeds vrijgegeven (tot vandaag)',
      upcomingRelease: 'Vrijgave op {{date}}',
      partialMonth: 'Dagtarief: {{dailyRate}} — deel van de lopende maand toegevoegd aan het saldo: {{amount}}',
      dailyRate: 'Dagtarief',
      daysEmployedCalculation: '{{days}} dagen × {{dailyRate}} (Dagtarief)',
      costsTitle: 'Kosten',
      otherMovementsTitle: 'Andere bewegingen',
      owedToEmployee: 'Verschuldigd aan werknemer: {{amount}}',
      owedByEmployee: 'Verschuldigd door werknemer: {{amount}}',
      nothingOwed: 'Niets verschuldigd in beide richtingen',
      yearSectionTitle: '{{year}}',
      projectedSuffix: '(geprojecteerd)',
      projectedBudgetNote: 'Er bestaat nog geen mobiliteitsrekening voor dit jaar — het bedrag hieronder is een schatting op basis van het huidige jaarbudget en wordt herberekend zodra een echte rekening wordt aangemaakt.',
    },
    vehicleLease: {
      title: 'Wagencategorie en leasingperiode',
      startDate: 'Startdatum leasingcontract',
      endDate: 'Einddatum leasingcontract',
      extendAction: 'Leaseperiode verlengen',
      extendTitle: 'Verlengen met een aantal maanden',
      extendExplanation: 'De maanden worden opgeteld bij de huidige einddatum {{endDate}}. Daarna kun je de bestaande berekening controleren voordat je opslaat.',
      extensionMonths: 'Aantal maanden',
      applyExtension: 'Verlenging toepassen',
      tcoMissing: 'Voor deze startdatum ontbreekt een TCO voor categorie {{entitled}} of {{vehicle}}. Stel die eerst in via TCO-categorieën, met een geldigheidsdatum op of vóór de start van de lease.',
      lockedAmounts: 'Vastgezet voor 48 maanden: recht {{entitled}} per maand, wagen {{vehicle}} per maand.',
      categoryRequired: 'Stel eerst de huidige categorie van de werknemer in.',
      entitledCategoryHelp: 'Begrensd door de actuele gerechtigdheid van de werknemer. Kies eventueel een lagere categorie voor de wagen.',
      explanation: 'Bij een nieuwe lease wordt standaard vier jaar ingevuld. Bij een verlenging blijven de oorspronkelijk vastgezette TCO-bedragen behouden.',
      calculate: 'Berekening controleren',
      previewTitle: 'Gevolgen van deze wijziging',
      previewSubtitle: 'Dit is een simulatie. Er wordt pas iets opgeslagen wanneer je hieronder bevestigt.',
      periodChange: 'Wijziging leasingperiode',
      entitledSnapshot: 'TCO-recht snapshot / maand',
      vehicleSnapshot: 'TCO wagen snapshot / maand',
      monthlyDifference: 'Vrij budget / maand',
      bookYearImpact: 'Verschil door deze wijziging',
      noBookYearImpact: 'Deze wijziging heeft geen invloed op de berekende boekjaren.',
      daysChange: '{{count}} dagen',
      activeDaysComparison: 'Actieve leasedagen: {{before}} → {{after}} van {{total}}',
      grossChange: 'Wijziging TCO-recht',
      vehicleCostChange: 'Wijziging wagenkost',
      freeBudgetChange: 'Wijziging vrij budget',
      calculationWarning: 'Door te bevestigen worden de leasegegevens opgeslagen en worden alle betrokken boekjaren en grootboekcorrecties opnieuw berekend. Controleer de periode, categorie en TCO-bedragen zorgvuldig.',
      confirmCalculation: 'Opslaan en budget herberekenen',
      saveAndCalculate: 'Opslaan en berekenen',
      saved: 'Leasingperiode en boekjaren zijn bijgewerkt.',
      historicalStartInfo: 'Je mag de werkelijke startdatum uit het verleden invullen. De toegewezen categorie en volledige TCO-set moeten op die datum geldig zijn. Zolang het mobiliteitsbudget uit staat, kan een eerder ingevoerde lease ook historisch worden gecorrigeerd.',
    },
    tco: {
      action: 'TCO-categorieën',
      title: 'TCO per wagencategorie',
      subtitle: 'Beheer de maandelijkse all-in kost die bij de start van een lease 48 maanden wordt vastgezet.',
      newVersion: 'Nieuwe TCO-versie',
      existingLeaseInfo: 'Bestaande leases behouden altijd hun oorspronkelijke bedragen.',
      effectiveFrom: 'Geldig vanaf',
      monthlyTco: 'Maandelijkse TCO',
      eurPerMonth: 'EUR / maand',
      loading: 'Laden…',
      saved: 'TCO voor categorie {{category}} opgeslagen.',
      setSaved: 'De volledige TCO-set is opgeslagen.',
      completeSetWarning: 'Een wijziging geldt altijd voor alle vier categorieën tegelijk. Na opslaan blijft deze set onveranderlijk in de historiek; correcties gebeuren met een nieuwe geldigheidsdatum.',
      saveCompleteSet: 'Volledige TCO-set opslaan',
      historyTitle: 'TCO-historiek',
      historySubtitle: 'Bekijk vroegere bedragen en hun geldigheidsperiode.',
      perMonth: 'per maand',
      perYear: 'per jaar',
      category: 'Categorie',
      monthlyAmount: 'Maandelijkse TCO',
      annualEquivalent: 'Equivalent per jaar',
      current: 'heden',
      noHistory: 'Nog geen TCO-historiek beschikbaar.',
    },
    claims: {
      title: 'Onkostennota\u2019s beoordelen',
      subtitle: 'Open een onkostennota om de gegevens en bewijsstukken te controleren voordat je een beslissing neemt.',
      approve: 'Goedkeuren',
      overBudgetWarning: 'Het beschikbare saldo is {{available}}. Voor goedkeuring is {{shortfall}} extra nodig dat nog niet beschikbaar is.',
      noDescription: 'Geen omschrijving',
      reject: 'Afwijzen',
      approved: 'Onkostennota goedgekeurd.',
      rejected: 'Onkostennota afgewezen.',
      rejectTitle: 'Onkostennota afwijzen',
      comment: 'Reden van afwijzing',
      reviewTitle: 'Onkostennota beoordelen',
      claimReference: 'Onkostennota #{{id}}',
      submittedAt: 'Ingediend op',
      supportingDocuments: 'Bewijsstukken',
      noSupportingDocuments: 'Er zijn geen bewijsstukken aan deze onkostennota toegevoegd.',
      noSupportingDocumentsCommute: 'Er zijn geen bewijsstukken toegevoegd. Voor woon-werkverkeer is dat niet vereist.',
      homeAddress: 'Thuisadres',
      workAddress: 'Werkadres',
      amountToBeCalculated: 'Te berekenen',
      distanceKm: 'Afstand',
      pricePerKm: 'Prijs per km',
      calculatedAmount: 'Berekend bedrag',
      requiredForApproval: 'Verplicht om goed te keuren.',
      lastPricePerKmHint: 'Overgenomen van de laatst goedgekeurde woon-werknota.',
      previousDistanceHint: 'Overgenomen van onkostennota #{{id}} met dezelfde adressen.',
      invalidDistance: 'Geef een afstand groter dan 0 in, met maximaal 2 decimalen.',
      invalidPricePerKm: 'Geef een prijs groter dan 0 in, met maximaal 4 decimalen.',
      distanceCalculation: 'Berekening',
      distanceBreakdown: '{{km}} km × {{rate}} per km',
      viewDocument: 'Bekijken',
      decisionHistory: 'Beslissingshistoriek',
      decisionTitle: 'Beslissing',
      decisionHelp: 'Controleer eerst alle gegevens en bewijsstukken. Een opmerking is optioneel bij goedkeuring en verplicht bij afwijzing.',
      reviewComment: 'Opmerking van de reviewer',
      commentRequiredForRejection: 'Verplicht wanneer je de onkostennota afwijst.',
      statusOverview: 'Overzicht per status',
      filters: {
        Pending: 'Te beoordelen',
        Approved: 'Goedgekeurd',
        Rejected: 'Afgewezen',
        Processed: 'Verwerkt',
        All: 'Alle',
      },
    },
    decisionType: {
      Approved: 'Goedgekeurd',
      Rejected: 'Afgewezen',
      ReturnedForInformation: 'Teruggestuurd voor bijkomende informatie',
    },
    claimStatus: {
      Draft: 'Concept',
      Submitted: 'Ingediend',
      UnderReview: 'In beoordeling',
      Approved: 'Goedgekeurd',
      Rejected: 'Afgewezen',
      PayrollReady: 'Klaar voor loon',
      Processed: 'Verwerkt',
      Cancelled: 'Geannuleerd',
    },
    payroll: {
      title: 'Loonverwerking',
      subtitle: 'Controleer goedgekeurde onkostennota’s en neem de geselecteerde nota’s op in een loonrun.',
      month: 'Maand',
      proForma: 'Voorbeeld bekijken',
      finalize: 'Loonrun aanmaken',
      proFormaDone: 'Voorbeeld opgebouwd met {{count}} regels. Dit voorbeeld wordt niet opgeslagen.',
      finalizeDone: 'Loonrun afgerond met {{count}} onkostennota’s.',
      reference: 'Overzicht',
      kind: 'Type',
      lines: 'Nota’s',
      total: 'Totaal bruto',
      createdAt: 'Aangemaakt op',
      approvedClaimsTitle: 'Klaar voor loonverwerking ({{count}})',
      approvedClaimsSubtitle: 'Deze goedgekeurde onkostennota’s wachten nog op een definitieve loonrun.',
      noApprovedClaims: 'Er zijn momenteel geen goedgekeurde onkostennota’s die op loonverwerking wachten.',
      processingPeriod: 'Verwerkingsperiode: {{period}}',
      processingPeriodLabel: 'Maand verwerken',
      historyPeriodLabel: 'Maand van uitvoering',
      periodAlreadyProcessed: '{{period}} werd al definitief verwerkt. Kies een andere maand om een nieuwe maandverwerking uit te voeren.',
      confirmTitle: 'Loonrun definitief aanmaken?',
      confirmSubtitle: 'Controleer de onkostennota’s die worden opgenomen voor {{period}}.',
      confirmSubtitleNoPeriod: 'Selecteer alle goedgekeurde onkostennota’s die in deze loonrun moeten worden opgenomen.',
      irreversibleTitle: 'Deze actie is onomkeerbaar',
      irreversibleText: 'De onderstaande nota’s worden definitief verwerkt. Alleen via een expliciete correctie met reden kan de volledige loonrun worden teruggedraaid.',
      summaryPeriod: 'Periode',
      summaryExecutionDate: 'Uitvoeringsdatum',
      summaryEmployees: 'Werknemers',
      summaryClaims: 'Onkostennota’s',
      summaryTotal: 'Totaal',
      includedClaims: 'Opgenomen onkostennota’s',
      includedClaimsSubtitle: 'Vink nota’s uit die nog niet in deze loonrun mogen worden opgenomen. De uitgavedatum beperkt de selectie niet.',
      confirmFinalize: 'Loonrun bevestigen',
      reverseAction: 'Loonrun terugdraaien',
      reverseTitle: 'Definitieve loonrun terugdraaien?',
      reverseExplanation: 'Alle nota’s uit deze loonrun keren terug naar Goedgekeurd. De bestaande loonrun blijft als Geannuleerd in de historiek staan, waarna je een gecorrigeerde run kunt maken.',
      reverseReason: 'Reden voor correctie',
      reverseConfirm: 'Terugdraaien en heropenen',
      reverseDone: 'De loonrun is teruggedraaid. De nota’s staan opnieuw klaar voor verwerking.',
      reversedLabel: 'Deze loonrun werd teruggedraaid',
      exportsTitle: 'Gegenereerde loonoverzichten',
      exportsSubtitle: 'Filter op de maand waarin de loonrun werd uitgevoerd en klik op een overzicht voor details of CSV-export.',
      exportDetails: 'Details loonoverzicht',
      generatedAt: 'Gegenereerd op',
      grossAmount: 'Brutobedrag',
      exportCsv: 'Exporteren als CSV',
      csvEmployee: 'Werknemer',
      csvPillarTwoCategory: 'Categorie pijler 2',
      csvDescription: 'Omschrijving',
      csvAmount: 'Brutobedrag',
      csvCurrency: 'Valuta',
      pillarTwoCategory: 'Categorie pijler 2',
      tabsLabel: 'Onderdelen loonverwerking',
      tabs: {
        payroll: 'Onkostennota’s en loonruns',
        pillarThree: 'Jaarafsluiting pijler 3',
      },
      kinds: {
        ProForma: 'Voorbeeld',
        Final: 'Definitief',
      },
      statuses: {
        Draft: 'Concept',
        Generated: 'Gegenereerd',
        Finalized: 'Definitief',
        Cancelled: 'Geannuleerd',
      },
    },
    pillarThree: {
      title: 'Jaarafsluiting pijler 3',
      subtitle: 'Controleer en verwerk het ongebruikte mobiliteitsbudget van een afgesloten boekjaar in één handeling.',
      explanation: 'Het resterende budget wordt bruto uitbetaald via pijler 3. Hierop wordt de bijzondere werknemersbijdrage van 38,07% ingehouden; het nettobedrag wordt aan de werknemer betaald.',
      gross: 'Bruto restsaldo',
      contribution: 'Bijdrage 38,07%',
      net: 'Netto uitbetaling',
      settledStatus: 'Verwerkt',
      readyStatus: 'Klaar voor verwerking',
      projectedStatus: 'Projectie',
      onlyClosedYears: 'Pijler 3 kan pas uitgevoerd worden nadat het geselecteerde boekjaar volledig is afgesloten.',
      settleAll: 'Alle verwerken ({{count}})',
      confirmTitle: 'Pijler 3 voor {{year}} uitvoeren?',
      confirmText: 'Voor {{count}} werknemers wordt het resterende budget definitief afgerekend en wordt de budgetrekening gesloten. Deze actie wordt in de historiek geregistreerd.',
      confirm: 'Definitief verwerken',
      completed: '{{count}} uitbetalingen verwerkt. Totaal netto: {{net}}.',
      exportCsv: 'Exporteren naar CSV',
    },
  },
};

export default nl;
